import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDoubleRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 16,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M23.0001875,24 C22.7016922,24 22.4061968,23.8875018 22.1782003,23.6595053 L11.3408697,12.8206747 C10.8863768,12.3676818 10.8863768,11.6326932 11.3408697,11.1797003 L22.1782003,0.340869674 C22.6326932,-0.113623225 23.3661818,-0.113623225 23.8206747,0.340869674 C24.2751676,0.793862596 24.2751676,1.52885111 23.8206747,1.98334401 L13.8023312,12.0001875 L23.8206747,22.018531 C24.2751676,22.4700239 24.2751676,23.2065124 23.8206747,23.6595053 C23.5941782,23.8875018 23.2971829,24 23.0001875,24",
			transform: "rotate(-180 17.58 12)"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12.0001875,24 C11.7016922,24 11.4061968,23.8875018 11.1782003,23.6595053 L0.340869674,12.8206747 C-0.113623225,12.3676818 -0.113623225,11.6326932 0.340869674,11.1797003 L11.1782003,0.340869674 C11.6326932,-0.113623225 12.3661818,-0.113623225 12.8206747,0.340869674 C13.2751676,0.793862596 13.2751676,1.52885111 12.8206747,1.98334401 L2.80233121,12.0001875 L12.8206747,22.018531 C13.2751676,22.4700239 13.2751676,23.2065124 12.8206747,23.6595053 C12.5941782,23.8875018 12.2971829,24 12.0001875,24",
			transform: "rotate(-180 6.58 12)"
		})]
	})
});
export default SvgChevronDoubleRight;
